/**
 * The contact-timeline row discriminator, in one place.
 *
 * `GET /api/contacts/{id}/timeline` merges two collections and stamps
 * `source: "communication"` on every row derived from `communications`
 * (`routes/contacts.py`). No writer stores that value — it is synthesised by
 * the timeline endpoint purely so the client can tell a real email from a CRM
 * activity, which is why a row's own `source` ("crm_composer", "gmail_sync",
 * "outlook_sync", "sequence_email", …) must never be allowed to overwrite it.
 *
 * #521 residue — this predicate previously existed as four hand-written copies
 * (ActivityCard's `isEmailRow`, ContactDetail's `expandedEmailRow` memo, and
 * the `emailFetchError` / `onRetryEmailFetch` props at the card's mount site).
 * They all read the same field, so when the expand-fetch merge clobbered it
 * they went dead together and the failure was silent. One definition instead.
 *
 * @param {object|null|undefined} row - a contact-timeline row
 * @returns {boolean} true when the row is an email from the communications collection
 */
export function isCommunicationEmailRow(row) {
    return Boolean(row)
        && row.source === 'communication'
        && (row.type || '').toLowerCase() === 'email';
}
